export const BLEED = 12;

// Translucent glass band. Without a real blur filter the "liquid" read comes
// from a thick gradient stroke (white -> teal) plus crisp inner/outer highlight
// lines and a few bubble rings.
export default function LiquidGlassFrame({ w, h, radius = 12 }) {
  const W = w + BLEED * 2;
  const H = h + BLEED * 2;
  const x = BLEED;
  const y = BLEED;
  const r = radius + 3;
  const rIn = Math.max(2, r - 4);
  const bubbles = [[x + w * 0.2, y], [x + w * 0.7, y], [x, y + h * 0.6], [x + w, y + h * 0.35]];
  return (
    <div style={{ position: 'absolute', top: -BLEED, left: -BLEED, width: W, height: H, pointerEvents: 'none' }}>
      <svg width={W} height={H} xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="lg_band" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#eafffb" stopOpacity={0.85} />
            <stop offset="0.5" stopColor="#7fd0cb" stopOpacity={0.35} />
            <stop offset="1" stopColor="#3f8f8a" stopOpacity={0.7} />
          </linearGradient>
        </defs>
        <rect x={x} y={y} width={w} height={h} rx={r} ry={r} fill="none" stroke="url(#lg_band)" strokeWidth={9} opacity={0.55} />
        <rect x={x - 3} y={y - 3} width={w + 6} height={h + 6} rx={r + 3} ry={r + 3} fill="none" stroke="#eafffb" strokeWidth={1} opacity={0.5} />
        <rect x={x + 4} y={y + 4} width={w - 8} height={h - 8} rx={rIn} ry={rIn} fill="none" stroke="#d9fff9" strokeWidth={0.8} opacity={0.6} />
        {bubbles.map(([cx, cy], i) => (
          <circle key={i} cx={cx} cy={cy} r={2.2} fill="none" stroke="#eafffb" strokeWidth={0.8} opacity={0.55} />
        ))}
      </svg>
    </div>
  );
}
